import '../../styles/Skeleton.css';

/**
 * Base skeleton block.
 * @param {number|string} width  - CSS width  (default '100%')
 * @param {number|string} height - CSS height (default 16)
 * @param {boolean} circle       - Render as circle
 * @param {boolean} rounded      - Larger border-radius
 * @param {string} className     - Extra classes
 * @param {object} style         - Extra inline styles
 */
const Skeleton = ({ width = '100%', height = 16, circle, rounded, className = '', style = {} }) => {
  const w = typeof width === 'number' ? `${width}px` : width;
  const h = typeof height === 'number' ? `${height}px` : height;

  return (
    <div
      className={`skeleton ${circle ? 'skeleton--circle' : ''} ${rounded ? 'skeleton--rounded' : ''} ${className}`}
      style={{ width: w, height: h, ...style }}
    />
  );
};

export default Skeleton;
